import React from "react";
import $ from "jquery";
import * as Icon from "@phosphor-icons/react";

import styles from "./login-form.css";

class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            schoolCode: "",
            username: "",
            password: "",

            status: "",
            uiState: ""
        };

        this.logIn = this.logIn.bind(this);
    }

    logIn(e) {
        e.preventDefault();

        this.setUIState("loggingIn");

        if (this.validFields()) {
            const loginData = {
                schoolCode: this.state.schoolCode,
                username: this.state.username,
                password: this.state.password,
                returnUrl: function () {
                    const urlParams = new URLSearchParams(window.location.search);
                    let returnUrl = urlParams.get("ReturnUrl");
                    return returnUrl;
                }()
            };

            $.ajax({
                url: "/account/login",
                method: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(loginData)
            })
            .done((response) => {
                if (response.success) {
                    window.location.href = response.returnUrl;
                }
                else {
                    this.setState({ status: response.errorMessage });
                    this.setUIState("dataEntry");
                }
            })
            .fail((error) => {
                this.setStatus("A problem during log in has occurred. Please try again.");
                this.setUIState("dataEntry");
            });
        }
        else {
            this.setUIState("dataEntry");
        }
    }

    validFields() {
        let isValid = true;

        let error = "";
        if (this.state.schoolCode.trim() === "") {
            error = "Please enter the school code.";
            isValid = false;
        }
        else if (this.state.username.trim() === "") {
            error = "Please enter your username.";
            isValid = false;
        }
        else if (this.state.password.trim() === "") {
            error = "Please enter your password.";
            isValid = false;
        }

        this.setStatus(error);

        return isValid;
    }

    setUIState(state) {
        this.setState({ uiState: state });
    }

    setStatus(status) {
        this.setState({ status: status });
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    handleChange(property, event) {
        this.setState({ [property]: event.target.value });
    }

    componentDidMount() {
        const schoolCode = this.getCookie("schoolCode");
        if (schoolCode !== null) {
            this.setState({ schoolCode: schoolCode });
            $("#username").focus();
        }
    }

    render() {
        return (
            <div styleName="login-background">
                <div styleName="login-container">
                    <div styleName="login-form">
                        <div styleName="login-title-page">OneSource School</div>
                        <div styleName="login-welcome-msg">
                            <Icon.HandWaving color="#ffb200" weight="fill" size={24} />
                            <h3 styleName="welcome">Welcome!</h3>
                            <p styleName="msg">Login to manage your school.</p>
                        </div>
                        <form onSubmit={this.logIn}>
                            <input type="text" styleName="login-form__input-text" value={this.state.schoolCode} onChange={(e) => this.handleChange("schoolCode", e)} name="schoolcode" placeholder="School Code" required autoFocus disabled={this.state.uiState === "loggingIn"} />
                            <input type="text" styleName="login-form__input-text" value={this.state.username} onChange={(e) => this.handleChange("username", e)} id="username" name="username" placeholder="Username" required disabled={this.state.uiState === "loggingIn"} />
                            <input type="password" styleName="login-form__input-text" value={this.state.password} onChange={(e) => this.handleChange("password", e)} name="password" placeholder="Password" required disabled={this.state.uiState === "loggingIn"} />
                            <button type="submit" styleName="login-form__button login-form__button--highlight" onClick={this.logIn} disabled={this.state.uiState === "loggingIn"}>Log In</button>
                            <div styleName="forgot-link-container">
                                <a href="/account/forgot" styleName="forgot-link">Forgot username or password?</a>
                            </div>
                            <span styleName="login-form__message">{this.state.status}</span>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginForm;